const editActivityNoteStyle = {
  editor: {
    backgroundColor: "background.note",
  },
  iconButtonContainer: {
    display: "block",
    marginLeft: "auto",
    marginRight: 0,
  },
};

export default editActivityNoteStyle;
